import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

import Navbar from "./components/Navbar";
import Products from "./pages/Products";
import Categories from "./pages/Categories";
import CategoryDetails from "./pages/CategoryDetails";
import Search from "./pages/Search";
import ProductDetails from "./pages/ProductDetails";

const API_KEY = "d0d0e4b5f11eccb0cab298bbb66068273ab5a3d145a993577cc9a94a761273f6";

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [telegramUserId, setTelegramUserId] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const [productsRes, categoriesRes] = await Promise.all([
          axios.get("https://xalavach.ru/api/products.php", {
            headers: { Authorization: `Bearer ${API_KEY}` },
          }),
          axios.get("https://xalavach.ru/api/categories.php", {
            headers: { Authorization: `Bearer ${API_KEY}` },
          }),
        ]);

        setProducts(
          productsRes.data.map((product) => ({
            ...product,
            image_url: `https://xalavach.ru/api/image.php?file=${product.avatar_image}`,
          }))
        );
        setCategories(categoriesRes.data);
        setIsLoading(false);
      } catch (err) {
        console.error("Ошибка загрузки данных:", err);
        setIsLoading(false);
      }
    }

    fetchData();
  }, []);

  // 📌 Исправленный механизм получения user_id из Telegram Mini App
  useEffect(() => {
    const checkTelegram = setInterval(() => {
      if (window.Telegram && window.Telegram.WebApp) {
        clearInterval(checkTelegram); // Останавливаем проверку
        console.log("✅ Telegram WebApp загружен");

        const telegram = window.Telegram.WebApp;
        telegram.ready();
        telegram.expand();

        const user = telegram.initDataUnsafe?.user;

        if (user) {
          console.log("✅ Получен user_id:", user.id);
          console.log("📢 Данные initDataUnsafe:", telegram.initDataUnsafe);
          setTelegramUserId(user.id);
        } else {
          console.error("❌ Пользователь не авторизован");
        }
      } else {
        console.warn("⏳ Ожидание загрузки Telegram WebApp...");
      }
    }, 500); // Проверяем каждые 500 мс
  }, []);

  if (isLoading) {
    return <div className="text-white text-center text-xl mt-20">Загрузка...</div>;
  }

  return (
    <div className="bg-gradient-to-br from-gray-900 via-[#0D1B2A] to-gray-800 min-h-screen">
      <Routes>
        <Route path="/" element={<><Navbar /><Products /></>} />
        <Route path="/categories" element={<><Navbar /><Categories /></>} />
        <Route path="/category/:id" element={<CategoryDetails products={products} categories={categories}  telegramUserId={telegramUserId} />} />
        <Route path="/search" element={<><Navbar /><Search  telegramUserId={telegramUserId} /></>} />
        <Route path="/product/:id" element={<ProductDetails products={products} categories={categories} telegramUserId={telegramUserId} />} />
      </Routes>
    </div>
  );
}
